export enum DocumentSigningStatuses {
    Pending = 1,
    Signed = 2,
    Cancelled = 3
}